import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowUp } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import style from './page-submit.module.scss.js';

const PageSubmit = () => {
  const label = useLabel();
  useLlm(state => state.components);
  const prompt = useLlm(state => state.prompt);
  const {
    send
  } = useLlmView(state => state.actions);
  const onSubmit = event => __awaiter(void 0, void 0, void 0, function* () {
    event && event.preventDefault();
    if (!prompt) {
      return;
    }
    yield send(prompt, response => {
      // console.log('PagePrompt.onChunk', response.chunks);
    }, response => {
      // console.log('PagePrompt.onEnd', response);
    });
  });
  return jsx("button", {
    type: "submit",
    className: getClassNames(style.submit),
    "aria-disabled": !prompt,
    "aria-label": label('llm.sendPrompt'),
    onClick: onSubmit,
    children: jsx(IconLlmArrowUp, {})
  });
};

export { PageSubmit };
//# sourceMappingURL=page-submit.js.map
